<template>
  <a
    v-if="lien"
    :href="lien"
    target="_blank"
    rel="noopener noreferrer"
    class="pappers-link"
  >
    Voir sur Pappers
    <i class="fas fa-external-link-alt" aria-hidden="true"></i>
    <span class="list-sr-only">(nouvel onglet)</span>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import { pappersUrl } from '../../utils/companySante.js'

/**
 * La fiche Pappers d'une entreprise, à côté de son SIRET. Le commercial y
 * recopiait le numéro à la main pour lire jugements, comptes et contentieux ;
 * le numéro lui-même reste copiable au clic, le lien est à part.
 */
const props = defineProps({
  siret: { type: String, default: null }
})

const lien = computed(() => pappersUrl(props.siret))
</script>

<style scoped>
.pappers-link {
  margin-left: var(--spacing-2);
  color: var(--color-primary);
  font-size: 0.85em;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.pappers-link:hover,
.pappers-link:focus-visible {
  text-decoration: underline;
}

.pappers-link i {
  font-size: 0.8em;
}
</style>
